import Grid from '@mui/material/Grid';
import { LegalProceedingsFiltersProps } from './props';
import { useLegalProceedingsFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import FieldText from '../../../../components/general/fields/fieldText';
import dayjs from 'dayjs';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import { formatParams } from '../../../../../shared/utils/params';

export const LegalProceedingsFilters = ({
    onFilter,
    loading,
}: LegalProceedingsFiltersProps) => {
    const { formik, statusList } = useLegalProceedingsFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha inicio"
                    name="startDate"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.startDate}
                    errors={formik.errors.startDate?.toString()}
                    value={formik.values.startDate}
                    onChange={(value) =>
                        formik.setFieldValue('startDate', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha fin"
                    name="endDate"
                    size="small"
                    minDate={
                        !formik.values.startDate
                            ? undefined
                            : dayjs(formik.values.startDate)
                    }
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.endDate}
                    errors={formik.errors.endDate?.toString()}
                    value={formik.values.endDate}
                    onChange={(value) =>
                        formik.setFieldValue('endDate', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre accionante"
                    name="nameClaimant"
                    size="small"
                    touched={formik.touched.nameClaimant}
                    errors={formik.errors.nameClaimant}
                    value={formik.values.nameClaimant}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Documento accionante"
                    name="documentClaimant"
                    size="small"
                    touched={formik.touched.documentClaimant}
                    errors={formik.errors.documentClaimant}
                    value={formik.values.documentClaimant}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={formatParams(statusList)}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número expediente"
                    name="fileNumber"
                    size="small"
                    touched={formik.touched.fileNumber}
                    errors={formik.errors.fileNumber}
                    value={formik.values.fileNumber}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
